<template>
<div>

  <!--Start 예약확인입력-->
  <div class="mask_contents-wrap" v-show="step == 0">
    <h1 class="title_type-a">예약 조회</h1>
    <div class="reservation-area reservation-search">
      <h2 class="title_type-b">예약자 정보 입력</h2>
      <div>
        <div class="new-join-wrap">
          <div class="ipt_area">
            <label for="ko_abo" class="form_label">ABO 번호</label>
            <input type="tel" class="form_ipt" id="ko_abo" v-model="abo_no" v-mask="'###########'">
          </div>
          <div class="ipt_area">
            <label for="ko_name" class="form_label">이름</label>
            <input type="text" class="form_ipt" id="ko_name" :value="name" @input="maxlengthName">
          </div>
          <div class="ipt_area">
            <label for="phone_number" class="form_label">휴대폰 번호(-없이 입력)</label>
            <input type="tel" class="form_ipt check_hyphen" id="phone_number" v-model="phone" v-mask="'###########'">
          </div>
        </div>
      </div>
    </div>
    <div class="btn-area">
      <button type="button" class="btn_type-a" @click="confirm" :disabled="isStartConfirm">예약 조회</button>
    </div>
  </div>
  <!--End 예약확인입력-->

  <!--Start 예약확인-->
  <div class="mask_contents-wrap" v-show="step == 1">
    <div class="reservation-info reservation-result">
      <h2 class="title_type-b">예약 정보</h2>
      <dl class="reservation_data">
        <dt class="reservation_title">예약 코드</dt>
        <dd class="reservation_value">{{ c_seq }}</dd>
      </dl>
      <dl class="reservation_data">
        <dt class="reservation_title">예약일</dt>
        <dd class="reservation_value">{{ c_date }}</dd>
      </dl>
      <dl class="reservation_data">
        <dt class="reservation_title">ABO 번호</dt>
        <dd class="reservation_value">{{ c_abo_no }}</dd>
      </dl>
      <dl class="reservation_data">
        <dt class="reservation_title">이름</dt>
        <dd class="reservation_value">{{ c_name }}</dd>
      </dl>
      <dl class="reservation_data">
        <dt class="reservation_title">휴대폰 번호</dt>
        <dd class="reservation_value">{{ c_phone }}</dd>
      </dl>
    </div>
    <div class="reservation_product">
      <div class="product_img" v-show="c_qty1 == '1'"><img src="./images/mask_big.jpg" alt=""></div>
      <div class="product_img" v-show="c_qty2 == '1'"><img src="./images/mask_small.jpg" alt=""></div>
      <div class="product_data">
        <p class="product_name">엣모스피어 스카이 미세먼지 마스크 KF94 {{c_qty1 == '1'?'대형':'소형'}} (30매)</p>
        <p class="product_sku">SKU : {{c_qty1 == '1'?'295882K':'295883K'}}</p>
        <p class="product_price"><span class="product_value">26,000</span>원 / <span class="product_value">1</span>개</p>
      </div>
    </div>
  </div>
  <!--End 예약확인-->
  <button type="button" class="layer_close" @click='redirectHome'>닫기</button>
</div>
</template>

<script>
import $ from 'jquery'
import Vue from 'vue'
import axios from 'axios'
import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

export default {
  name: 'atmosphere-mask-confirm',
  data () {
    return {
      step: 0,
      options: [
        { text: '0개', value: '0' },
        { text: '1개', value: '1' }
      ],
      seq: '',
      date: '',
      abo_no: '',
      name: '',
      phone: '',
      qty1: '0',
      qty2: '0',
      isStartConfirm: false,
      isStartCancel: false,
      isStartModify: false,
      c_seq: '',
      c_date: '',
      c_abo_no: '',
      c_name: '',
      c_phone: '',
      c_qty1: '0',
      c_qty2: '0',
    }
  },
  methods: {
    init () {
      this.seq = ''
      this.date = ''
      this.abo_no = ''
      this.name = ''
      this.phone = ''
      this.qty1 = '0'
      this.qty2 = '0'
      this.isStartConfirm = false
      this.isStartCancel = false
      this.isStartModify = false
    },
    maxlengthName (event) {
      const value = event.target.value
      if (String(value).length <= 50) {
        this.name = value.trim()
      }
      this.$forceUpdate()
    },
    valid () {
      if (!this.abo_no) {
        alert('ABO번호를 입력하세요.')
        return false
      } else if (this.abo_no.length < 5) {
        alert('ABO번호를 5자리 이상으로 입력해 주세요.')
        return false
      } else if (!this.name) {
        alert('이름을 입력하세요.')
        return false
      } else if (!this.phone) {
        alert('휴대폰번호를 입력하세요.')
        return false
      } else if (this.phone.length < 10) {
        alert('휴대폰번호를 10자리 이상으로 입력해 주세요.')
        return false
      }
      return true
    },
    confirm () {
      if (this.valid()) {
        this.isStartConfirm = true
        axios.post(process.env.AWS_GATEWAY_URL + '/masks', {
          abo_no: this.abo_no,
          name: this.name,
          phone: this.phone
        }, {
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(response => {
          console.log('response : ', JSON.stringify(response, null, 2))
          if (response.status === 200) {
            if (response.data.ABO_NO === 'E') {
              alert('예약된 정보를 찾을 수 없습니다.')
            } else if (response.data === 'ERROR') {
              alert('죄송합니다.예약조회자가 많아서 현재 조회가 지연되고 있습니다.\n다시 시도해 주세요.')
            } else {
              this.isStartConfirm = false
              return this.gotoConfirm(response.data)
            }
          } else {
            alert('죄송합니다.예약조회자가 많아서 현재 조회가 지연되고 있습니다.\n다시 시도해 주세요.')
          }
          this.isStartConfirm = false
        }).catch(error => {
          console.log('error : ', error)
          alert('죄송합니다.예약조회자가 많아서 현재 조회가 지연되고 있습니다.\n다시 시도해 주세요.')
          this.isStartConfirm = false
        })
        this.isStartConfirm = false
      }
    },
    gotoConfirm (data) {
      this.c_seq = btoa(data.ABO_NO)
      this.c_abo_no = data.ABO_NO
      this.c_name = data.Name
      this.c_phone = data.Phone
      this.c_date = data.Date
      this.c_qty1 = data.QTY1
      this.c_qty2 = data.QTY2
      this.step = 1
      this.init()
    },
    validExcptABO () {
      if (this.qty1 !== '0') {
        axios.post(process.env.AWS_GATEWAY_URL + '/mask/except', {
          abo_no: this.abo_no
        }, {
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(response => {
          console.log('response : ', JSON.stringify(response, null, 2))
          if (response.status === 200) {
            if (response.data.result === 'DUP') {
              alert('이미 대형마스크를 구매하셔서 선택할수 없습니다.')
              this.qty1 = '0'
            }
          } else {
            alert('죄송합니다.예약조회자가 많아서 현재 조회가 지연되고 있습니다.\n다시 시도해 주세요.')
          }
        }).catch(error => {
          console.log('error : ', error)
          alert('죄송합니다.예약조회자가 많아서 현재 조회가 지연되고 있습니다.\n다시 시도해 주세요.')
        })
      }
    },
    cancel () {
      this.isStartCancel = true
      if (this.valid()) {
        axios.post(process.env.AWS_GATEWAY_URL + '/mask/d', {
          abo_no: this.abo_no,
          name: this.name,
          phone: this.phone
        }, {
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(response => {
          console.log('response : ', JSON.stringify(response, null, 2))
          if (response.status === 200) {
            if (response.data.result === 'PASS') {
              alert('정상적으로 취소되었습니다.')
              this.isStartCancel = false
              return this.gotoCancelComplete()
            } else {
              alert('죄송합니다.예약조회자가 많아서 현재 조회가 지연되고 있습니다.\n다시 시도해 주세요.')
            }
          } else {
            alert('죄송합니다.예약조회자가 많아서 현재 조회가 지연되고 있습니다.\n다시 시도해 주세요.')
          }
          this.isStartCancel = false
        }).catch(error => {
          console.log('error : ', error)
          alert('죄송합니다.예약조회자가 많아서 현재 조회가 지연되고 있습니다.\n다시 시도해 주세요.')
          this.isStartCancel = false
        })
      }
      this.isStartCancel = false
    },
    gotoCancelComplete () {
      this.step = 2
    },
    modify () {
      this.isStartModify = true
      if (this.valid()) {
        axios.post(process.env.AWS_GATEWAY_URL + '/mask/u', {
          abo_no: this.abo_no,
          name: this.name,
          phone: this.phone,
          qty1: this.qty1,
          qty2: this.qty2
        }, {
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(response => {
          console.log('response : ', JSON.stringify(response, null, 2))
          if (response.status === 200) {
            if (response.data.result === 'PASS') {
              alert('정상적으로 수정되었습니다.')
              this.isStartModify = false
              return this.gotoModifyComplete()
            } else if (response.data.result === 'QTY_Limit' || response.data.result === 'QTY1_Limit' || response.data.result === 'QTY2_Limit') {
              alert('예약가능 수량이 없습니다.')
            }
          } else {
            alert('죄송합니다.예약조회자가 많아서 현재 조회가 지연되고 있습니다.\n다시 시도해 주세요.')
          }
          this.isStartModify = false
        }).catch(error => {
          console.log('error : ', error)
          alert('죄송합니다.예약조회자가 많아서 현재 조회가 지연되고 있습니다.\n다시 시도해 주세요.')
          this.isStartModify = false
        })
      }
      this.isStartModify = false
    },
    gotoModifyComplete () {
      this.step = 3
    },
    redirectHome() {
      var url = 'https://www.amway.co.kr'
      window.open(url, "_self");
    }
  },
  created: function () {
    var utag_data = {
      site_type : 'responsive', //  desktop /mobile
      site_country : 'kr', //  kr 고정
      site_language : 'ko', //  ko 고정
      site_subGroup : 'korea', //  korea 고정
      site_subRegion : 'korea', //  korea 고정
      site_region : 'apac',//  apac 고정
      site_webProperty : 'ecm', //  ecm 고정
      site_currencyCode : 'krw', //
      page_section : '미세먼지마스크',
      page_category : '조회', // 공백없이 입력
      page_subcategory : '', // 
      page_detail : '미세먼지마스크예약자정보입력',
      visitor_imcID: '18000007480003',
      visitor_pinNumber: 'platinum', //this can be a descriptive value (e.g., platinum, silver_producer, diamond, etc.)
      visitor_userProfile: 'abo'
    }
  },
  mounted: function () {
    document.title = '엣모스피어 마스크 예약조회'
    window.addEventListener('DOMContentLoaded', function () {
      $('.form_ipt').not('.ipt_area_change .form_ipt').each(function () {
        var thisInput = $(this)
        var paDiv = thisInput.parent()
        thisInput.on('focus focusout', function (e) {
          if (e.type === 'focus') {
            if (!paDiv.hasClass('on')) {
              paDiv.addClass('on')
            }
          } else if (e.type === 'focusout') {
            if (thisInput.val() === '') {
              paDiv.removeClass('on')
            }
          }
        })
      })
    })

    $(function(a,b,c,d){
        //a='//tags.tiqcdn.com/utag/amway/kr-hybris/dev/utag.js';// 개발/QA환경인 경우
        a='//tags.tiqcdn.com/utag/amway/kr-hybris/prod/utag.js';// Production 환경인 경우
        b=document;c='script';d=b.createElement(c);d.src=a;d.type='text/java'+c;d.async=true;
        a=b.getElementsByTagName(c)[0];a.parentNode.insertBefore(d,a);
    });
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Noto+Sans+KR:300,400,500,700&subset=korean');
@import './css/mask.css';
</style>



// WEBPACK FOOTER //
// src/views/atmosphere-mask/confirm.vue